import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "Home", to: "/", testId: "navbar-home-link" },
  { label: "The Program", to: "/the-program", testId: "navbar-program-link" },
];

export const Navbar = () => {
  const { pathname } = useLocation();

  return (
    <header
      className="fixed left-0 top-0 z-40 w-full px-3 py-3 md:px-10 md:py-4"
      data-testid="site-navbar"
    >
      <nav
        className="mx-auto flex w-full max-w-6xl items-center justify-between rounded-full border border-[#DCCDBB] bg-[#FDFBF7]/85 px-3 py-2 backdrop-blur-md md:px-7 md:py-3"
        data-testid="site-navbar-inner"
      >
        <p
          className="font-clean whitespace-nowrap text-xs font-bold tracking-[0.04em] text-[#3F322A] sm:text-sm md:text-lg"
          data-testid="site-navbar-brand"
        >
          SHYRA BHALLA
        </p>

        <div className="flex items-center gap-1.5 sm:gap-2 md:gap-6" data-testid="site-navbar-links-wrap">
          {navItems.map((item) => {
            const isActive = pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={item.testId}
                className={`whitespace-nowrap rounded-full px-2 py-1 text-[11px] transition-colors duration-300 sm:px-2.5 sm:text-xs md:px-3 md:py-1.5 md:text-base ${
                  isActive
                    ? "bg-[#4A3B32] text-[#FDFBF7]"
                    : "text-[#6B5A4E] hover:bg-[#EFE6D8]"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </div>
      </nav>
    </header>
  );
};
